import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import registerServiceWorker from "./registerServiceWorker";
import LanguageWrapper from "./components/common/Localization/LanguageWrapper";
import IdleTimer from "./components/IdleTimer";
import { Auth0Provider } from "./auth/auth0-wrapper";

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById("root");
const onRedirectCallback = appState => {
  window.history.replaceState(
    {},
    document.title,
    appState && appState.targetUrl ? appState.targetUrl : window.location.pathname
  )
};
ReactDOM.render(
  <Auth0Provider onRedirectCallback={onRedirectCallback}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <LanguageWrapper>
            <IdleTimer/>
        </LanguageWrapper>
      </ConnectedRouter>
    </Provider>
  </Auth0Provider>,
  rootElement
);

registerServiceWorker();
